import { foxfireCells } from './signature';
import type { HeroDefinition } from '../types';

/** Foxfire — lean a scatter of berries toward the tile you tap. */
export const cleo: HeroDefinition = {
  id: 'cleo',
  name: 'Cleo',
  species: 'fox',
  classId: 'stealth',
  powerName: 'Foxfire',
  color: 'berry',
  description: 'Turns a scatter of tiles into berries, leaned toward a tap.',
  target: 'area',
  paw: 'cc_hero_cleo_paw@1x.png',
  apply(state, _player, target) {
    const center = target ?? {
      r: Math.floor((state.config.boardH - 1) / 2),
      c: Math.floor((state.config.boardW - 1) / 2),
    };
    const pick = foxfireCells(state, center);
    return {
      clear: [],
      convert: pick.map((position) => ({ position, color: 'berry' as const })),
    };
  },
};
